export const Heading = (props) => {
    const { children } = props;

    return(
        <h6 {...props}>
            { children }
        </h6>
    );
}